export default __webpack_public_path__ + "static/media/IMG-20240822-WA0016.eae88917.jpg";